import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectProps,
  useTheme,
} from "@mui/material";
import {forwardRef} from "react";

type Props = SelectProps & {
  data: string[] | {name: string; value: string | number | boolean}[];
  placeholder?: string;
};

const ProcessSelect = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const theme = useTheme();
  const value = props.value === null ? "" : props.value;

  return (
    <FormControl fullWidth size="small">
      <InputLabel
        htmlFor={props.name}
        sx={{
          color: props.disabled
            ? theme.palette.grey[300]
            : theme.palette.grey[500],
        }}
      >
        {props.label}
      </InputLabel>
      <Select
        inputProps={{
          id: props.name,
          name: `select-${props.name}`,
        }}
        {...props}
        value={value}
        inputRef={ref}
      >
        {!props.value && (
          <MenuItem disabled value="">
            <em>{props.placeholder ?? "Selecione"}</em>
          </MenuItem>
        )}
        {props.data.map((item) => (
          <MenuItem
            key={typeof item === "string" ? item : item.value}
            value={typeof item === "string" ? item : item.value}
          >
            {typeof item === "string" ? item : item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
});

ProcessSelect.displayName = "ProcessSelect";

export default ProcessSelect;
